import React from "react";
import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import Layout from "./Components/layout";
import ScrollToTop from "./Components/scrolltotop";
import About_Us from "./Components/aboutus";
import Contact_Us from "./Components/contactus";
import Home from "./Components/home/Home";
import Gallery from "./Components/gallery";
import ForceReload from "./Components/scrolltotop/forcereload";

function App() {
  return (
    <HashRouter>
      <Layout>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About_Us />} />

          <Route path="/contactus" element={<Contact_Us />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App;
